"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderModules = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * renderModules function for mapping and rendering the modules
 * @method
 * @param {Object} data - Passing data object as an argument
 */

// TODO talk to Jeremy about using AsyncComponent instead or passing these down from web-site OR pass in the anonymous function to handle the loading of these modules
// TODO will need tests (followup ticket created)
const renderModules = data => {
  const {
    modules
  } = data;
  const hasModules = modules && modules.length > 0;
  if (!hasModules) {
    return null;
  }
  return modules.map((module, index) => {
    return /*#__PURE__*/_react.default.createElement("div", _extends({
      key: "".concat(module.id, "-gridModule-").concat(index)
    }, module));
  });
};
exports.renderModules = renderModules;